import { Injectable } from '@angular/core';
import { Volume } from '../interfaces/volume';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VolumeCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/settings/volumes/' ;
  }

  // Create Volume
  add(record: Volume) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Volume Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Volumes List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Volume Object
  update(record: Volume) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Volume>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Volume Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}
